module.exports = __webpack_public_path__ + "static/media/en.f26ea422.png";